module.exports = __webpack_public_path__ + "static/img/暂无排班@2x.5de1f22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/暂无排班@2x.png
// module id = 295
// module chunks = 379 380